var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRankDiamondNoRibbonLightMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.086C8.8 3.086 3.086 8.8 3.086 16c0 1.6.343 3.086.8 4.457L20.457 3.886c-1.371-.571-2.857-.8-4.457-.8z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.457 3.885L3.886 20.457C5.714 25.485 10.4 28.914 16 28.914c7.2 0 12.914-5.829 12.914-12.914 0-5.6-3.428-10.286-8.457-12.114z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.571C22.286 4.571 27.43 9.714 27.43 16c0 6.286-5.143 11.428-11.429 11.428-6.285 0-11.428-5.142-11.428-11.428C4.572 9.714 9.715 4.57 16 4.57zm0-2.285C8.458 2.286 2.286 8.457 2.286 16S8.458 29.714 16 29.714c7.543 0 13.715-6.171 13.715-13.714S23.543 2.286 16 2.286z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.457 8.8c3.772 0 6.514 2.972 6.514 7.2 0 4.229-2.628 7.2-6.514 7.2h-4.686V8.8h4.686zm-1.943 11.886h1.943C18.63 20.686 20 18.857 20 16c0-2.743-1.486-4.571-3.543-4.571h-1.943v9.257z",
    fill: "#fff"
  })));
}

export default SvgIconRankDiamondNoRibbonLightMode;